export default "__VITE_ASSET__BK5g2N8G__"